<div class="app-wrapper" *ngIf="access">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content settings-section">
      <div class="app-main">
        <header>
          <div class="data-header">
            <core-title-section
            [title]="'Categories'"
            [description]="'Here you can create a structure for your tags, and color code the categories.'"
            [breadcrumbs]="breadcrumbs"
            ></core-title-section>
            <div class="button-settings-add">
              <core-helpers-navigation-three-dots-menu
                [menu]="menu"
                (action)="onMenuClick($event)"
              ></core-helpers-navigation-three-dots-menu>
            </div>
          </div>
          <!-- <div class="instructions">
            <a (click)="showInstructions = !showInstructions" class="trigger" [ngClass]="{'opened' : showInstructions}"><em>How does this work?</em></a>
            <ol *ngIf="showInstructions">
              <li >Click on <strong>ADD A NEW CATEGORY</strong>, give it a name and click on <strong>ADD CATEGORY</strong>.</li>
              <li >Once it appears on the list, assign it a <strong>COLOR FOR VISUAL IDENTIFICATION</strong>. This can be changed.</li>
              <li ><strong>DEACTIVATE</strong> categories, or reactivate them from the list.</li>
            </ol>
          </div> -->
        </header>
        <div class="labels-group-add" [hidden]="!showForm">
          <settings-labels-groups-add-form (cancel)="showForm = false" (submit)="onSaved($event)"></settings-labels-groups-add-form>
        </div>
        <div class="box_default box_white labels-groups-list">
          <div class="" *ngIf="status == STATUS_DONE">
            <h3><span>CATEGORIES</span></h3>
            <ul class="labels-group-ul">
              <core-helpers-lists-one-action-color-list-item
              *ngFor="let lblgrp of labelsGroups | sortByActive"
              [colorOptions] = "colorOptions"
              [color]="lblgrp.color"
              [title]="lblgrp.name"
              [actionText]="lblgrp.active? 'Deactivate' : 'Activate'"
              (actionClick)="lblgrp.active? deactivate(lblgrp) : activate(lblgrp)"
              (colorChange)="onColorChange($event,lblgrp)"
              [type]="lblgrp.active? 'disabled': 'inactive'"
              ></core-helpers-lists-one-action-color-list-item>
            </ul>
          </div>
          <div class="loader">
            <div class="dimmed" [hidden]="status == STATUS_DONE">
              <div class="dimmed_title"></div>
              <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
              </div>
              <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
              </div>
              <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
              </div>
            </div>
            <!-- <core-helpers-box-loading [hidden]="status == STATUS_DONE"></core-helpers-box-loading> -->
          </div>
        </div>
      </div>
    </section>
</div>


<core-helpers-box-http-error *ngIf="!access" [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
